import type { IconData } from '@stacksjs/iconify-core'

export const screwdriverSolid: IconData = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M42.338 1.809a1.5 1.5 0 0 0-1.75-.272l-5.907 3.06a2.5 2.5 0 0 0-1.349 2.159l-.092 3.76l-8.404 8.405c.635.598 1.35 1.29 2.15 2.091a102 102 0 0 1 2.093 2.151l8.404-8.404l3.76-.092a2.5 2.5 0 0 0 2.16-1.349l3.059-5.906a1.5 1.5 0 0 0-.271-1.75zM21.166 19.633a81 81 0 0 1 3.697 3.5a81 81 0 0 1 3.501 3.698c1.512 1.718 1.556 4.165.179 5.954c-1.234 1.602-3.23 3.994-6.1 6.866c-2.873 2.872-5.265 4.867-6.867 6.1c-1.789 1.378-4.236 1.333-5.954-.178a81 81 0 0 1-3.697-3.5a81 81 0 0 1-3.501-3.698C.913 36.657.869 34.21 2.246 32.42c1.233-1.602 3.228-3.994 6.1-6.866s5.264-4.867 6.866-6.1c1.789-1.378 4.236-1.334 5.954.178\" clip-rule=\"evenodd\"/>",
  "width": 48,
  "height": 48,
  "viewBox": "0 0 48 48"
}

export default screwdriverSolid
